import { getByDomain } from '@/config/sites';

function siteUrl() {
  const ThemeDetection = getByDomain();
  if (ThemeDetection && ThemeDetection.site) {
    return ThemeDetection.site;
  }
  return 'https://www.jobnet.ag';
}

const site = siteUrl();

export const navigation = [
  {
    title: 'Jobnet.AG',
    url: `${site}/JobnetAG/`,
    child: [
      {
        title: 'Profil',
        url: `${site}/JobnetAG/`,
      },
      {
        title: 'Aufsichtsrat',
        url: `${site}/JobnetAG/Aufsichtsrat.php`,
      },
      {
        title: 'Vorstand',
        url: `${site}/JobnetAG/Vorstand.php`,
      },
      {
        title: 'Team',
        url: `${site}/JobnetAG/Team/`,
      },
      {
        title: 'Standorte',
        url: `${site}/JobnetAG/Standorte/`,
      },
      {
        title: 'Netzwerk',
        url: `${site}/Netzwerk/`,
      },
      {
        title: 'Newsletter',
        url: `${site}/JobnetAG/Newsletter/`,
      },
      {
        title: 'Kontakt',
        url: `${site}/JobnetAG/Kontakt/`,
        child: [
          {
            title: 'So erreichen Sie uns',
            url: `${site}/JobnetAG/Kontakt/`,
          },
          {
            title: 'Impressum',
            url: `${site}/JobnetAG/Kontakt/impressum.php`,
          },
          {
            title: 'Support & Webinare',
            url: `${site}/JobnetAG/Kontakt/Support-Webinare.php`,
          },
          {
            title: 'Datenschutz',
            url: `${site}/JobnetAG/datenschutz.php`,
          },
        ],
      },
      {
        title: 'Karriere',
        url: `${site}/JobnetAG/Karriere/`,
      },
    ],
  },
  {
    title: 'Solutions',
    url: `${site}/Solutions/?nav=1`,
    child: [
      {
        title: 'Plattformen für Arbeit, Personal und Bildung',
        url: `${site}/Solutions/Plattformen/`,
        description: 'Schneller und besser in neue Beschäftigung vermitteln',
        child: [
          {
            title: 'Jobnet.Jobs: regionale Stellenplattform - JobZENTRALE',
            url: `${site}/Solutions/Plattformen/Jobnet.Jobs/?nav=0`,
          },
          {
            title: 'Jobtalent.Space: Plattform für Arbeit, Personal und Bildung',
            url: `${site}/Solutions/Plattformen/Jobtalent.Space/`,
          },
          {
            title: 'Jobnet.Courses: Maßnahmen-Informations-Tool für Jobcenter',
            url: `${site}/Solutions/Plattformen/Jobnet.Courses/`,
          },
        ],
      },
      {
        title: 'Potenzialdiagnostik, Erwerbsfähigkeit, Eignungsdiagnostik',
        url: `${site}/Solutions/Diagnostik/`,
        description: 'Talente, Stärken und Handlungsbedarfe erkennen, neue Impulse setzen',
        child: [
          {
            title: 'Jobnet.Fit - Zukunftsprofil',
            url: `${site}/Solutions/Diagnostik/Jobnet.Fit-Zukunftsprofil/`,
          },
          {
            title: 'Jobnet.Coach - Jobimpuls-Methode',
            url: `${site}/Solutions/Diagnostik/Jobnet.Coach-Jobimpuls/?nav=produkt`,
          },
          {
            title: 'padaCura - Erwerbsfähigkeit',
            url: `${site}/Solutions/Diagnostik/padaCura/`,
          },
          {
            title: 'CuraSkill - Pflegetalente',
            url: `${site}/Solutions/Diagnostik/CuraSkill/`,
          },
        ],
      },
      {
        title: 'Lernplattformen',
        url: `${site}/Solutions/Lernplattformen/?nav=produkt`,
        description: 'Modernes Lernen unterstützen, Kosten sparen - auch berufsbegleitend',
      },
      {
        title: 'Community-Lösungen',
        url: `${site}/Solutions/Community/?nav=2`,
        description: 'Gemeinschaft fördern, Isolation überwinden, Lösungspartner vernetzen',
      },
      {
        title: 'Business Intelligence, Integration und Kommunikation',
        url: `${site}/Solutions/Business-Intelligence/`,
        description: 'Arbeitsmarktintegration wirksam steuern, Prozesse optimieren',
      },
      {
        title: 'Künstliche Intelligenz: Jobtalent.AI',
        url: `${site}/Solutions/Artificial-Intelligence/`,
        description: 'Skill-Analyse, Skill-Matching, Bewerbungsassistent, Such- und Formulierungshilfen, agentische KI',
      },
    ],
  },
  {
    title: 'Consulting',
    url: `${site}/Consulting/`,
    child: [
      {
        title: 'Beratung und Projektmanagement',
        url: `${site}/Consulting/Beratung/?nav=0`,
        description: 'Organisationsberatung, IT-Beratung, Projektmanagement: Akzeptanz und Nutzen sichern',
      },
      {
        title: 'Training und Coaching: Jobnet.Academy',
        url: `${site}/Consulting/Jobnet.Academy/?nav=0`,
        description: 'Anwendungs- und Beratungssicherheit erreichen, Einsatz optimieren',
      },
    ],
  },
  {
    title: 'Services',
    url: `${site}/Services/`,
    child: [
      {
        title: 'Partnermanagement, Administration und Support',
        url: `${site}/Services/Partnermanagement/?nav=0`,
        description: 'Proaktive Unterstützung, Impulse für kontinuierliche Verbesserungen',
      },
      {
        title: 'Finanzen',
        url: `${site}/Services/Finanzen/`,
        description: 'Rechnungswesen und allgemeine Verwaltung',
      },
    ],
  },
  {
    title: 'International',
    url: `${site}/International/`,
    child: [
      {
        title: 'Österreich',
        url: `${site}/International/Oesterreich/`,
        child: [
          {
            title: 'Übersicht',
            url: `${site}/International/Oesterreich/`,
          },
          {
            title: 'Aktuelles aus Österreich',
            url: `${site}/International/Oesterreich/Aktuelles-aus-Oesterreich/`,
          },
          {
            title: 'Kundenstandorte',
            url: `${site}/International/Oesterreich/Standorte/?we_anchor=tab2#tab2`,
          },
          {
            title: 'Referenzen',
            url: `${site}/International/Oesterreich/Referenzen/?we_anchor=at#at`,
          },
          {
            title: 'Unser Team',
            url: `${site}/International/Oesterreich/Unser-Team/`,
          },
          {
            title: 'Kundenstimmen',
            url: `${site}/International/Oesterreich/Kundenstimmen/?catid=54`,
          },
        ],
      },
      {
        title: 'Philippinen',
        url: `${site}/International/Philippinen/`,
      },
      {
        title: 'Ukraine',
        url: `${site}/International/Ukraine/`,
      },
      {
        title: 'Indien',
        url: `${site}/International/Indien/`,
      },
    ],
  },
  {
    title: 'Kunden',
    url: `${site}/Kunden/`,
    child: [
      {
        title: 'Jobcenter',
        url: `${site}/Kunden/Jobcenter/`,
      },
      {
        title: 'Bildungsträger',
        url: `${site}/Kunden/Bildungstraeger/`,
      },
      {
        title: 'Berufliche Reha',
        url: `${site}/Kunden/Berufliche-Reha/`,
      },
      {
        title: 'Transfergesellschaften',
        url: `${site}/Kunden/Transfergesellschaften/`,
      },
      {
        title: 'Wirtschaft+Fachkräfte',
        url: `${site}/Kunden/Wirtschaft-Fachkraefte/`,
      },
      {
        title: 'Referenzen',
        url: `${site}/Kunden/Referenzen/`,
      },
      {
        title: 'Kundenstimmen',
        url: `${site}/Kunden/Kundenstimmen/`,
      },
    ],
  },
  {
    title: 'News',
    url: `${site}/News/?news`,
    child: [
      {
        title: 'Aktuelles von der Jobnet.AG',
        url: `${site}/News/?news`,
      },
      {
        title: 'Die Jobnet.AG in der Presse',
        url: `${site}/News/Presse/`,
      },
    ],
  },
];
